import { cn } from "@rosette/ts/src/util/cn.js";


const ringClasses = "absolute m-[10%] block size-4/5 rounded-[50%] border-8";
const spinnerClasses = cn(ringClasses, "border-transparent border-t-white animate-spinner");


interface LoadingSpinnerProps {
    className?: string;
}

export function LoadingSpinner({ className }: LoadingSpinnerProps) {
    return (
        <div className={cn("relative inline-block size-[80px]", className ?? null)}>
            <div className={cn(ringClasses, "border-surface-sunken")}></div>
            <div className={spinnerClasses}></div>
            <div className={cn(spinnerClasses, "[animation-delay:-0.15s]")}></div>
            <div className={cn(spinnerClasses, "[animation-delay:-0.3s]")}></div>
            <div className={cn(spinnerClasses, "[animation-delay:-0.45s]")}></div>
        </div>
    );
}
